import Common from "../../Common";

const StandardCallMethod = class extends Common {
	update = (userId: id, body: { mobile_account_id: id, desktop_account_id: id }) => this.patch(`/user/${userId}/standardcallmethod`, body)
}

export default StandardCallMethod
